// --- FILE: src/pages/AdminLoginPage.jsx (ESTILO AJUSTADO A TEMA OSCURO) ---
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Lock, LogIn, Eye, EyeOff, Shield } from 'lucide-react';

const AdminLoginPage = () => {
  const { login, loading, error } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try { 
      await login(email, password); 
    } catch (err) { 
      console.error(err); 
    }
  };

  return (
    // Fondo con gradiente para coincidir con AdminReportPage
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        {/* Elementos de fondo decorativos, ajustados para tonos oscuros */}
        <div className="absolute -top-40 -right-40 w-80 h-80 rounded-full bg-gradient-to-br from-white/5 to-transparent blur-3xl opacity-30"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 rounded-full bg-gradient-to-tr from-white/3 to-transparent blur-3xl opacity-30"></div>
      </div>
      <div className="relative z-10 w-full max-w-md">
        {/* Contenedor del formulario, usando fondo semitransparente con blur y borde */}
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 shadow-2xl">
          <div className="text-center mb-8">
            <img 
              src="/LogoNibpr.png" 
              alt="NIB" 
              className="w-20 h-auto filter brightness-0 invert mx-auto mb-6" // Invertir colores para logo oscuro en fondo claro
            />
            <h1 className="text-3xl font-bold text-white mb-2">Terminal de Empleados</h1>
            <p className="text-white/60 text-sm">Sistema de gestión y control de turnos</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-white/80 mb-2">Correo de Administrador</label>
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-4 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50" // Color de focus ajustado
                  placeholder="admin@nibpr.com"
                  required
                />
                <Shield className="w-5 h-5 text-white/40 absolute right-4 top-1/2 -translate-y-1/2" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-white/80 mb-2">Contraseña</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-4 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 pr-12" // Color de focus ajustado
                  placeholder="••••••••••••"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>
            {error && (
              <div className="p-3 rounded-xl bg-red-500/20 text-red-300 text-sm text-center border border-red-400"> {/* Borde para el error */}
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-4 px-6 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition-all duration-300 disabled:opacity-50 flex items-center justify-center gap-2 shadow-lg" // Botón primario azul
            >
              {loading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white/20 border-t-white rounded-full animate-spin"></div> {/* Spinner blanco para fondo oscuro */}
                  <span>Verificando...</span>
                </>
              ) : (
                <>
                  <LogIn size={20} />
                  <span>Acceder al Sistema</span>
                </>
              )}
            </button>
          </form>
          <div className="mt-8 text-center text-xs text-white/40">
            <p>Sistema seguro de gestión empresarial</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;